/* Compatibilité : Firefox ne prend pas encore en charge la division de longueurs CSS. */
(() => {
  if (CSS.supports('transform', 'scale(calc(100cqw / 1440px))')) return;
  const update = element => {
    const scale = Math.min(1, element.clientWidth / 1440);
    element.style.setProperty('--v5-scale', String(scale));
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));
  const observe = root => root.querySelectorAll('.v5f').forEach(element => {
    update(element);
    observer.observe(element);
  });
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
